import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        filePath: '<'
    },
    template: `
    <div class="pv-presentation-viewer" ng-class="{'pv-fullscreen-mode': vm.isFullscreen}">
      <!-- Toolbar -->
      <div class="pv-presentation-toolbar">
        <div class="pv-toolbar-section pv-toolbar-left">
          <button class="pv-tool-btn" ng-click="vm.toggleFullscreen()" title="Full Screen">
            <span class="pv-btn-icon">{{ vm.isFullscreen ? '⊗' : '⛶' }}</span>
          </button>
          <span class="pv-file-name">{{ vm.fileName }}</span>
        </div>

        <div class="pv-toolbar-section pv-toolbar-center pv-toolbar-desktop-only">
          <button class="pv-tool-btn" ng-click="vm.goToPreviousSlide()" ng-disabled="vm.currentSlide === 0">
            <span class="pv-btn-icon">‹</span>
          </button>

          <div class="pv-page-indicator">
            <input
              type="number"
              class="pv-page-input"
              ng-model="vm.inputSlide"
              ng-blur="vm.goToInputSlide()"
              ng-keydown="vm.handleSlideInput($event)"
              min="1"
              max="{{ vm.totalSlides }}"
              ng-disabled="vm.totalSlides === 0">
            <span class="pv-page-total">of {{ vm.totalSlides }}</span>
          </div>

          <button class="pv-tool-btn" ng-click="vm.goToNextSlide()" ng-disabled="vm.currentSlide === vm.totalSlides - 1">
            <span class="pv-btn-icon">›</span>
          </button>
        </div>

        <div class="pv-toolbar-section pv-toolbar-right">
          <button class="pv-tool-btn" ng-click="vm.zoomOut()" ng-disabled="vm.zoomLevel <= 0.5" title="Zoom Out (-)">
            <span class="pv-btn-icon">−</span>
          </button>

          <div class="pv-zoom-indicator pv-zoom-desktop-only" ng-click="vm.resetZoom()" title="Reset Zoom">
            {{ vm.zoomLevel * 100 | number:0 }}%
          </div>

          <button class="pv-tool-btn" ng-click="vm.zoomIn()" ng-disabled="vm.zoomLevel >= 2" title="Zoom In (+)">
            <span class="pv-btn-icon">+</span>
          </button>
        </div>
      </div>

      <!-- Mobile Page Indicator Overlay -->
      <div class="pv-mobile-page-indicator">
        <span class="pv-mobile-page-text">{{ vm.currentSlide + 1 }} / {{ vm.totalSlides }}</span>
      </div>

      <!-- Loading State -->
      <div class="pv-presentation-loading" ng-if="vm.isInitialLoading">
        <div class="pv-spinner-large"></div>
        <div class="pv-loading-text">Loading presentation...</div>
        <div class="pv-loading-subtext" ng-if="vm.status === 'processing' || vm.status === 'converting'">
          Converting presentation, please wait...
        </div>
      </div>

      <!-- Error State -->
      <div class="pv-presentation-error" ng-if="vm.hasError">
        <div class="pv-error-icon">⚠️</div>
        <div class="pv-error-text">{{ vm.errorMessage }}</div>
        <button class="pv-error-retry" ng-click="vm.retry()">Retry</button>
      </div>

      <!-- Scroll Container -->
      <div class="pv-presentation-content"
           id="presentationContent"
           ng-if="!vm.isInitialLoading && !vm.hasError">

        <!-- Fullscreen Transition Loader -->
        <div class="pv-fullscreen-transition-loader" ng-if="vm.isFullscreenTransitioning">
          <div class="pv-spinner-medium"></div>
        </div>

        <!-- Navigation Buttons -->
        <button class="pv-carousel-nav pv-carousel-nav-left"
                ng-click="vm.goToPreviousSlide()"
                ng-if="vm.currentSlide > 0">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path d="M15 18l-6-6 6-6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </button>

        <button class="pv-carousel-nav pv-carousel-nav-right"
                ng-click="vm.goToNextSlide()"
                ng-if="vm.currentSlide < vm.totalSlides - 1">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path d="M9 18l6-6-6-6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </button>

        <div class="pv-scroll-wrapper"
             ng-style="{'transform': 'scale(' + vm.zoomLevel + ')'}">
          <div class="pv-scroll-container"
               id="slideScroller">
            <!-- Generate all slides -->
            <div class="pv-slide"
                 ng-repeat="slideIndex in vm.getSlideIndices() track by slideIndex"
                 id="slide-{{ slideIndex }}"
                 data-slide-index="{{ slideIndex }}">
              <div class="pv-slide-inner">
                <!-- Only load iframe if slide should be loaded -->
                <iframe
                  ng-if="vm.shouldLoadSlide(slideIndex)"
                  ng-src="{{ vm.getSlideUrl(slideIndex) }}"
                  class="pv-slide-iframe"
                  sandbox="allow-scripts allow-same-origin allow-popups allow-popups-to-escape-sandbox allow-top-navigation allow-top-navigation-by-user-activation"
                  scrolling="no"
                  onload="try { this.contentDocument.body.style.cssText = 'margin: 0 !important; padding: 0 !important; overflow: hidden !important;'; } catch(e) {}"
                ></iframe>
                <!-- Show placeholder for unloaded slides -->
                <div ng-if="!vm.shouldLoadSlide(slideIndex)" class="pv-slide-placeholder">
                  <div class="pv-placeholder-number">{{ slideIndex + 1 }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <style>
        .pv-presentation-viewer {
          display: flex;
          flex-direction: column;
          height: 100vh;
          width: 100%;
          background: #f5f5f5;
          font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
          overflow: hidden;
          position: relative;
          margin: 0 !important;
          padding: 0 !important;
        }

        .pv-presentation-viewer.pv-fullscreen-mode {
          position: fixed;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          z-index: 0;
        }

        /* Toolbar */
        .pv-presentation-toolbar {
          display: flex;
          align-items: center;
          justify-content: space-between;
          background: #ffffff;
          border-bottom: 1px solid #e0e0e0;
          padding: 8px 16px;
          height: 48px;
          flex-shrink: 0;
          box-shadow: 0 1px 3px rgba(0, 0, 0, 0.06);
          z-index: 10;
        }

        .pv-toolbar-section {
          display: flex;
          align-items: center;
          gap: 8px;
          flex: 1;
        }

        .pv-toolbar-left { justify-content: flex-start; }
        .pv-toolbar-center { justify-content: center; gap: 4px; }
        .pv-toolbar-right { justify-content: flex-end; }

        .pv-file-name {
          font-size: 13px;
          color: #495057;
          margin-left: 8px;
          font-weight: 500;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          max-width: 200px;
        }

        .pv-tool-btn {
          background: #f8f9fa;
          border: 1px solid #dee2e6;
          border-radius: 4px;
          padding: 6px 12px;
          cursor: pointer;
          color: #495057;
          font-size: 16px;
          transition: all 0.2s ease;
          display: flex;
          align-items: center;
          justify-content: center;
          min-width: 36px;
          height: 32px;
          user-select: none;
        }

        .pv-tool-btn:hover:not(:disabled) {
          background: #e9ecef;
          border-color: #ced4da;
        }

        .pv-tool-btn:disabled {
          opacity: 0.4;
          cursor: not-allowed;
        }

        .pv-btn-icon {
          font-size: 20px;
          line-height: 1;
        }

        /* Page Indicator */
        .pv-page-indicator {
          display: flex;
          align-items: center;
          gap: 6px;
          padding: 0 8px;
        }

        .pv-page-input {
          width: 50px;
          padding: 4px 8px;
          border: 1px solid #dee2e6;
          border-radius: 4px;
          text-align: center;
          font-size: 13px;
          color: #495057;
          background: #fff;
        }

        .pv-page-input:focus {
          outline: none;
          border-color: #80bdff;
        }

        .pv-page-input::-webkit-outer-spin-button,
        .pv-page-input::-webkit-inner-spin-button {
          -webkit-appearance: none;
          margin: 0;
        }

        .pv-page-input[type=number] {
          -moz-appearance: textfield;
        }

        .pv-page-total {
          color: #6c757d;
          font-size: 13px;
          white-space: nowrap;
        }

        /* Zoom */
        .pv-zoom-indicator {
          padding: 4px 8px;
          color: #495057;
          font-size: 13px;
          cursor: pointer;
          user-select: none;
          min-width: 55px;
          text-align: center;
          border-radius: 4px;
          font-weight: 500;
        }

        .pv-zoom-indicator:hover {
          background: #f8f9fa;
        }

        /* Mobile Page Indicator Overlay */
        .pv-mobile-page-indicator {
          display: none;
          position: fixed;
          bottom: 20px;
          left: 50%;
          transform: translateX(-50%);
          z-index: 25;
          background: rgba(0, 0, 0, 0.75);
          color: #fff;
          padding: 8px 16px;
          border-radius: 20px;
          font-size: 14px;
          font-weight: 500;
          backdrop-filter: blur(10px);
          pointer-events: none;
          user-select: none;
          box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
        }

        .pv-mobile-page-text {
          display: block;
          white-space: nowrap;
        }

        /* Loading/Error States */
        .pv-presentation-loading,
        .pv-presentation-error {
          flex: 1;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          background: #fff;
        }

        .pv-spinner-large {
          width: 64px;
          height: 64px;
          border: 5px solid #e9ecef;
          border-top-color: #495057;
          border-radius: 50%;
          animation: pv-spin 0.8s linear infinite;
        }

        @keyframes pv-spin {
          to { transform: rotate(360deg); }
        }

        .pv-spinner-medium {
          width: 48px;
          height: 48px;
          border: 4px solid #e9ecef;
          border-top-color: #495057;
          border-radius: 50%;
          animation: pv-spin 0.8s linear infinite;
        }

        .pv-loading-text {
          margin-top: 20px;
          color: #495057;
          font-size: 16px;
          font-weight: 500;
        }

        .pv-loading-subtext {
          margin-top: 8px;
          color: #6c757d;
          font-size: 13px;
        }

        .pv-error-icon {
          font-size: 64px;
          margin-bottom: 16px;
        }

        .pv-error-text {
          color: #dc3545;
          font-size: 16px;
          margin-bottom: 20px;
          text-align: center;
          max-width: 400px;
        }

        .pv-error-retry {
          background: #007bff;
          color: #fff;
          border: none;
          border-radius: 4px;
          padding: 8px 24px;
          font-size: 14px;
          cursor: pointer;
        }

        .pv-error-retry:hover {
          background: #0056b3;
        }

        /* Fullscreen Transition Loader */
        .pv-fullscreen-transition-loader {
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background: rgba(233, 236, 239, 0.95);
          display: flex;
          align-items: center;
          justify-content: center;
          z-index: 30;
          backdrop-filter: blur(4px);
        }

        /* Scroll Content */
        .pv-presentation-content {
          flex: 1;
          display: flex;
          align-items: center;
          justify-content: center;
          background: #e9ecef;
          overflow: hidden;
          position: relative;
        }

        /* Navigation Buttons */
        .pv-carousel-nav {
          position: absolute;
          top: 50%;
          transform: translateY(-50%);
          z-index: 20;
          width: 48px;
          height: 48px;
          border-radius: 50%;
          background: rgba(255, 255, 255, 0.95);
          border: 1px solid rgba(0, 0, 0, 0.1);
          box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
          cursor: pointer;
          display: flex;
          align-items: center;
          justify-content: center;
          color: #495057;
          transition: all 0.2s ease;
          backdrop-filter: blur(8px);
          -webkit-tap-highlight-color: transparent;
        }

        .pv-carousel-nav:hover {
          background: rgba(255, 255, 255, 1);
          box-shadow: 0 6px 16px rgba(0, 0, 0, 0.2);
          transform: translateY(-50%) scale(1.05);
        }

        .pv-carousel-nav:active {
          transform: translateY(-50%) scale(0.95);
        }

        .pv-carousel-nav:disabled {
          opacity: 0.3;
          cursor: pointer;
          background: rgba(255, 255, 255, 0.5);
          pointer-events: none;
        }

        .pv-carousel-nav-left { left: 20px; }
        .pv-carousel-nav-right { right: 20px; }

        /* Scroll Wrapper with Zoom */
        .pv-scroll-wrapper {
          width: 100%;
          height: 100%;
          display: flex;
          align-items: center;
          justify-content: center;
          transform-origin: center center;
          transition: transform 0.2s ease;
          overflow: hidden;
        }

        /* Horizontal Scroll Container with Snap */
        .pv-scroll-container {
          display: flex;
          gap: 40px;
          padding: 40px;
          overflow: auto;
          scroll-snap-type: x mandatory;
          scroll-behavior: smooth;
          -webkit-overflow-scrolling: touch;
          scrollbar-width: none;
          -ms-overflow-style: none;
          height: 100%;
          align-items: center;
          box-sizing: border-box;
        }

        .pv-scroll-container::-webkit-scrollbar {
          display: none;
          width: 0;
          height: 0;
        }

        /* Individual Slide */
        .pv-slide {
          flex-shrink: 0;
          scroll-snap-align: center;
          scroll-snap-stop: always;
          width: 900px;
          max-width: 85vw;
        }

        .pv-fullscreen-mode .pv-slide {
          width: 1400px;
          max-width: 85vw;
        }

        .pv-slide-inner {
          position: relative;
          width: 100%;
          padding-bottom: 56.25%;
          background: #fff;
          box-shadow: 0 8px 32px rgba(0, 0, 0, 0.2);
          border-radius: 4px;
          overflow: hidden;
        }

        .pv-slide-iframe {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          border: none;
          display: block;
        }

        /* Placeholder for unloaded slides */
        .pv-slide-placeholder {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background: linear-gradient(135deg, #f0f0f0 0%, #e0e0e0 100%);
          display: flex;
          align-items: center;
          justify-content: center;
        }

        .pv-placeholder-number {
          font-size: 64px;
          font-weight: 700;
          color: rgba(0, 0, 0, 0.1);
        }

        /* Responsive */
        @media (max-width: 768px) {
          .pv-file-name { display: none; }

          .pv-toolbar-desktop-only {
            display: none !important;
          }

          .pv-zoom-desktop-only {
            display: none !important;
          }

          .pv-mobile-page-indicator {
            display: block;
          }

          .pv-presentation-toolbar {
            padding: 8px 12px;
            height: 44px;
          }

          .pv-toolbar-left {
            justify-content: flex-start;
          }

          .pv-toolbar-right {
            gap: 4px;
          }

          .pv-tool-btn {
            min-width: 34px;
            height: 30px;
            padding: 4px 10px;
          }

          .pv-carousel-nav {
            width: 56px;
            height: 56px;
            box-shadow: 0 6px 16px rgba(0, 0, 0, 0.2);
          }

          .pv-carousel-nav svg {
            width: 28px;
            height: 28px;
          }

          .pv-carousel-nav-left { left: 8px; }
          .pv-carousel-nav-right { right: 8px; }

          /* MOBILE FIX: Much larger slides with minimal padding */
          .pv-scroll-container {
            gap: 20px;
            padding: 20px 10px;
          }

          .pv-slide {
            width: calc(100vw - 20px);
            max-width: calc(100vw - 20px);
            min-width: calc(100vw - 20px);
          }

          .pv-slide-inner {
            box-shadow: 0 4px 16px rgba(0, 0, 0, 0.15);
          }

          .pv-scroll-container::-webkit-scrollbar {
            display: none !important;
            width: 0 !important;
            height: 0 !important;
          }
        }

        @media (max-width: 480px) {
          .pv-presentation-toolbar {
            height: 40px;
            padding: 6px 8px;
          }

          .pv-tool-btn {
            min-width: 30px;
            height: 28px;
            padding: 4px 8px;
            font-size: 14px;
          }

          .pv-btn-icon {
            font-size: 18px;
          }

          .pv-carousel-nav {
            width: 48px;
            height: 48px;
          }

          .pv-carousel-nav svg {
            width: 24px;
            height: 24px;
          }

          .pv-carousel-nav-left { left: 6px; }
          .pv-carousel-nav-right { right: 6px; }

          .pv-mobile-page-indicator {
            bottom: 16px;
            padding: 6px 14px;
            font-size: 13px;
          }

          /* MOBILE FIX: Even larger slides on small screens */
          .pv-scroll-container {
            gap: 16px;
            padding: 16px 8px;
          }

          .pv-slide {
            width: calc(100vw - 16px);
            max-width: calc(100vw - 16px);
            min-width: calc(100vw - 16px);
          }
        }

        .pv-fullscreen-mode .pv-scroll-container {
            align-items: start;
        }

        @media (min-height: 475px) {
            .pv-fullscreen-mode .pv-scroll-container {
              align-items: center;
            }
        }
      </style>
    </div>
  `
})
export default class {
    constructor (
        MaterialFileResource,
        $sce,
        $window,
        $scope,
        $timeout,
        $document
    ) {
        this.MaterialFileResource = MaterialFileResource;
        this.$sce = $sce;
        this.$window = $window;
        this.$scope = $scope;
        this.$timeout = $timeout;
        this.$document = $document;

        this.currentSlide = 0;
        this.inputSlide = 1;
        this.totalSlides = 0;
        this.isFullscreen = false;
        this.zoomLevel = 1;
        this.filenameHash = '';
        this.fileName = '';
        this.status = '';
        this.fileType = 'file';

        this.isInitialLoading = true;
        this.hasError = false;
        this.errorMessage = '';

        this.isTransitioning = false;
        this.isFullscreenTransitioning = false;

        this.loadedSlides = {};
        this.loadRange = 2;

        this.isProgrammaticScroll = false;
        this.intersectionObserver = null;
    }

    $onInit () {
        const match = this.filePath.match(/material-chapter-file\/([a-f0-9]{64})/);
        this.filenameHash = match ? match[1] : null;

        if (!this.filenameHash) {
            this.hasError = true;
            this.errorMessage = 'Invalid file path.';
            this.isInitialLoading = false;
            return;
        }

        this.loadMetadata();

        this.onKeydown = this.onKeydown.bind(this);
        this.onWheel = this.onWheel.bind(this);

        this.$document.on('keydown', this.onKeydown);

        this.$timeout(() => {
            const content = this.$document[0].getElementById('presentationContent');
            if (content) {
                content.addEventListener('wheel', this.onWheel, { passive: false });
            }

            // Set up IntersectionObserver to detect visible slides
            this.setupIntersectionObserver();
        }, 0);

        this.$window.addEventListener('message', (event) => {
            if (event.data.type === 'material-preview-fullscreen-entered') {
                this.isFullscreen = true;
                this.isTransitioning = true;
                if (!this.$scope.$phase) this.$scope.$apply();

                this.$timeout(() => {
                    this.$timeout(() => {
                        this.repositionToCurrentSlide();
                        this.isTransitioning = false;
                    }, 150);
                }, 100);
            }
            else if (event.data.type === 'material-preview-fullscreen-exited') {
                this.isFullscreen = false;
                this.isTransitioning = true;
                if (!this.$scope.$phase) this.$scope.$apply();

                this.$timeout(() => {
                    this.$timeout(() => {
                        this.repositionToCurrentSlide();
                        this.isTransitioning = false;
                    }, 150);
                }, 100);
            }
            else if (event.data.type === 'presentation-navigate-to-slide') {
                // Handle internal slide navigation from iframe links
                const targetSlideIndex = event.data.slideIndex;

                // Validate slide index
                if (typeof targetSlideIndex === 'number' &&
                    targetSlideIndex >= 0 &&
                    targetSlideIndex < this.totalSlides) {
                    // Navigate to the target slide
                    this.goToSlide(targetSlideIndex);

                    // Apply scope changes if not in digest cycle
                    if (!this.$scope.$phase) {
                        this.$scope.$apply();
                    }
                }
            }
        });

        this.$scope.$on('$destroy', () => {
            this.$document.off('keydown', this.onKeydown);

            const content = this.$document[0].getElementById('presentationContent');
            if (content) content.removeEventListener('wheel', this.onWheel);

            // Clean up IntersectionObserver
            if (this.intersectionObserver) {
                this.intersectionObserver.disconnect();
            }
        });
    }

    setupIntersectionObserver () {
        // Create an IntersectionObserver to detect which slide is most visible
        const options = {
            root: this.$document[0].getElementById('slideScroller'),
            threshold: [0, 0.25, 0.5, 0.75, 1.0],
            rootMargin: '0px'
        };

        this.intersectionObserver = new IntersectionObserver((entries) => {
            // Skip if we're programmatically scrolling or transitioning
            if (this.isProgrammaticScroll || this.isTransitioning) return;

            // Find the most visible slide (highest intersection ratio)
            let mostVisibleEntry = null;
            let highestRatio = 0;

            entries.forEach(entry => {
                if (entry.intersectionRatio > highestRatio) {
                    highestRatio = entry.intersectionRatio;
                    mostVisibleEntry = entry;
                }
            });

            // Update current slide if we found a highly visible one (>60% threshold to be more confident)
            if (mostVisibleEntry && highestRatio > 0.6) {
                const slideIndex = parseInt(mostVisibleEntry.target.getAttribute('data-slide-index'), 10);

                if (!isNaN(slideIndex) && slideIndex !== this.currentSlide) {
                    this.currentSlide = slideIndex;
                    this.inputSlide = slideIndex + 1;
                    this.updateLoadedSlides();

                    if (!this.$scope.$phase) {
                        this.$scope.$apply();
                    }
                }
            }
        }, options);

        // Observe all slide elements
        this.$timeout(() => {
            const slides = this.$document[0].querySelectorAll('.pv-slide');
            slides.forEach(slide => {
                this.intersectionObserver.observe(slide);
            });
        }, 100);
    }

    loadMetadata () {
        this.isInitialLoading = true;
        this.hasError = false;

        this.MaterialFileResource.getStatus({ filenameHash: this.filenameHash })
            .$promise.then((data) => {
                this.status = data.status;
                this.fileName = data.filename_before_converting;
                this.fileType = data.type || 'file';
                this.totalSlides = data.slide_count || 0;

                if (this.status === 'failed') {
                    this.hasError = true;
                    this.errorMessage = 'Presentation conversion failed.';
                    this.isInitialLoading = false;
                    return;
                }

                if (this.status === 'processing' || this.status === 'converting') {
                    this.$timeout(() => this.loadMetadata(), 3000);
                    return;
                }

                if (this.fileType !== 'presentation' || this.totalSlides === 0) {
                    this.hasError = true;
                    this.errorMessage = 'This file is not a valid presentation.';
                    this.isInitialLoading = false;
                    return;
                }

                this.isInitialLoading = false;
                this.inputSlide = 1;

                this.updateLoadedSlides();

                // Set up observer after slides are rendered
                this.$timeout(() => {
                    this.setupIntersectionObserver();
                }, 100);
            })
            .catch(() => {
                this.hasError = true;
                this.errorMessage = 'Failed to load presentation.';
                this.isInitialLoading = false;
            });
    }

    updateLoadedSlides () {
        const minSlide = Math.max(0, this.currentSlide - this.loadRange);
        const maxSlide = Math.min(this.totalSlides - 1, this.currentSlide + this.loadRange);

        for (let i = minSlide; i <= maxSlide; i++) {
            this.loadedSlides[i] = true;
        }
    }

    shouldLoadSlide (index) {
        return this.loadedSlides[index] === true;
    }

    retry () {
        this.loadMetadata();
    }

    getSlideIndices () {
        const indices = [];
        for (let i = 0; i < this.totalSlides; i++) {
            indices.push(i);
        }
        return indices;
    }

    getSlideUrl (index) {
        const url = `${SEED_CORE.ENV.API_URL}course/material-chapter-file/${this.filenameHash}/slide/${index}`;
        return this.$sce.trustAsResourceUrl(url);
    }

    goToPreviousSlide () {
        if (this.currentSlide > 0) {
            this.goToSlide(this.currentSlide - 1);
        }
    }

    goToNextSlide () {
        if (this.currentSlide < this.totalSlides - 1) {
            this.goToSlide(this.currentSlide + 1);
        }
    }

    goToSlide (index) {
        if (index >= 0 && index < this.totalSlides) {
            // Prevent multiple rapid clicks
            if (this.isProgrammaticScroll) {
                return;
            }

            // Mark as programmatic scroll to prevent observer updates
            this.isProgrammaticScroll = true;

            const slide = this.$document[0].getElementById(`slide-${index}`);

            if (slide) {
                slide.scrollIntoView({
                    behavior: 'smooth',
                    block: 'nearest',
                    inline: 'center'
                });

                // CRITICAL: Delay state update so button doesn't disappear immediately
                // This prevents clicks from landing on the slide instead of the button
                this.$timeout(() => {
                    this.currentSlide = index;
                    this.inputSlide = index + 1;
                    this.updateLoadedSlides();
                }, 300);

                // Re-enable observer after scroll completes
                this.$timeout(() => {
                    this.isProgrammaticScroll = false;
                }, 500);
            }
            else {
                this.isProgrammaticScroll = false;
            }
        }
    }

    goToInputSlide () {
        const slideNum = parseInt(this.inputSlide, 10);
        if (slideNum >= 1 && slideNum <= this.totalSlides) {
            this.goToSlide(slideNum - 1);
        }
        else {
            this.inputSlide = this.currentSlide + 1;
        }
    }

    handleSlideInput (event) {
        if (event.keyCode === 13) {
            event.target.blur();
            this.goToInputSlide();
        }
    }

    zoomIn () {
        if (this.zoomLevel < 2) {
            this.zoomLevel = Math.min(2, this.zoomLevel + 0.1);
            this.zoomLevel = Math.round(this.zoomLevel * 10) / 10;
        }
    }

    zoomOut () {
        if (this.zoomLevel > 0.5) {
            this.zoomLevel = Math.max(0.5, this.zoomLevel - 0.1);
            this.zoomLevel = Math.round(this.zoomLevel * 10) / 10;
        }
    }

    resetZoom () {
        this.zoomLevel = 1;
    }

    getSelfSrc () {
        return (
            (this.$window.frameElement &&
                this.$window.frameElement.getAttribute('src')) ||
            this.filePath
        );
    }

    toggleFullscreen () {
        this.isFullscreen = !this.isFullscreen;
        this.isTransitioning = true;
        this.isFullscreenTransitioning = true;

        this.$window.parent.postMessage(
            {
                type: 'material-preview-fullscreen',
                src: this.getSelfSrc()
            },
            '*'
        );

        this.$timeout(() => {
            this.$timeout(() => {
                this.repositionToCurrentSlide();

                this.$timeout(() => {
                    this.isFullscreenTransitioning = false;
                    this.isTransitioning = false;
                }, 400);
            }, 100);
        }, 50);
    }

    exitFullscreen () {
        this.isFullscreen = false;
        this.$window.parent.postMessage(
            {
                type: 'material-preview-exit',
                src: this.getSelfSrc()
            },
            '*'
        );
    }

    repositionToCurrentSlide () {
        const slide = this.$document[0].getElementById(`slide-${this.currentSlide}`);

        if (slide) {
            // Temporarily disable observer during repositioning
            this.isProgrammaticScroll = true;

            slide.scrollIntoView({
                behavior: 'auto',
                block: 'nearest',
                inline: 'center'
            });

            this.$timeout(() => {
                this.isProgrammaticScroll = false;
            }, 500);
        }
    }

    onWheel (e) {
        if (e.ctrlKey || e.metaKey) {
            e.preventDefault();

            if (e.deltaY < 0) this.zoomIn();
            else this.zoomOut();
            if (!this.$scope.$phase) this.$scope.$apply();
        }
    }

    onKeydown (e) {
        if (e.target.tagName === 'INPUT' || e.target.tagName === 'TEXTAREA') return;

        let handled = false;

        switch (e.keyCode) {
        case 37:
        case 33:
            this.goToPreviousSlide();
            handled = true;
            break;
        case 39:
        case 34:
        case 32:
            this.goToNextSlide();
            handled = true;
            break;
        case 36:
            this.goToSlide(0);
            handled = true;
            break;
        case 35:
            this.goToSlide(this.totalSlides - 1);
            handled = true;
            break;
        case 187:
        case 107:
            if (e.ctrlKey || e.metaKey) {
                this.zoomIn();
                handled = true;
            }
            break;
        case 189:
        case 109:
            if (e.ctrlKey || e.metaKey) {
                this.zoomOut();
                handled = true;
            }
            break;
        case 48:
        case 96:
            if (e.ctrlKey || e.metaKey) {
                this.resetZoom();
                handled = true;
            }
            break;
        case 27:
            if (this.isFullscreen) {
                this.exitFullscreen();
                handled = true;
            }
            break;
        default:
            break;
        }

        if (handled) {
            e.preventDefault();
            if (!this.$scope.$phase) this.$scope.$apply();
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/components/courses/authoringTool/iframe/htmlViewer/index.js